"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPanelTransitionProps = void 0;

var getPanelTransitionProps = function getPanelTransitionProps(onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate) {
  return {
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    onCloseStart: onCloseStart,
    onCloseComplete: onCloseComplete,
    align: align,
    duration: animate ? undefined : 0
  };
};

exports.getPanelTransitionProps = getPanelTransitionProps;